import { render, staticRenderFns } from "./KitchenCounters.vue?vue&type=template&id=0312c30e&scoped=true&"
import script from "./KitchenCounters.vue?vue&type=script&lang=js&"
export * from "./KitchenCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0312c30e",
  null
  
)

export default component.exports